export var ShippingMethodType;
(function (ShippingMethodType) {
    ShippingMethodType["Internal"] = "internal";
    ShippingMethodType["ThirdParty"] = "third_party";
    ShippingMethodType["ParkAndMunch"] = "park_and_munch";
})(ShippingMethodType || (ShippingMethodType = {}));
